import React, { useState, useRef, useEffect } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography, Tooltip } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

interface AgentNodeData {
  label: string;
  provider?: string;
  model?: string;
  apiKey?: string;
  instructions?: string;
  hideOutputHandle?: boolean;
}

const AgentNode: React.FC<NodeProps<AgentNodeData>> = ({ data = { label: 'Agent' } }) => {
  console.log('AgentNode data:', data, 'hideOutputHandle:', data.hideOutputHandle); // Debug log

  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
  }, [data.label]);

  return (
    <Box
      sx={{
        width: 140,
        height: 40,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #80BFFF',
        px: 1,
        outline: 'none',
        '&:focus': {
          outline: 'none',
        },
        '&:hover': {
          outline: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: 18,
          height: 18,
          backgroundColor: '#3B82F6',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1,
        }}
      >
        <SmartToyIcon sx={{ color: '#ffffff', fontSize: 10 }} />
      </Box>
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <Tooltip title={isTruncated ? data.label : ''} arrow placement="top" disableHoverListener={!isTruncated}>
          <Typography ref={textRef} variant="body2" sx={{ fontWeight: 500, fontSize: '9px', lineHeight: 1.2, color: '#1F2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {data.label}
          </Typography>
        </Tooltip>
        {data.provider && data.model && (
          <Typography variant="caption" sx={{ fontSize: '7px', color: '#6B7280' }}>
            ✨ {data.provider}: {data.model}
          </Typography>
        )}
      </Box>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#000000', width: 5, height: 5 }}
      />
      {!data.hideOutputHandle && (
        <Handle
          type="source"
          position={Position.Right}
          style={{ background: '#000000', width: 5, height: 5 }}
        />
      )}
    </Box>
  );
};

export default AgentNode;
